import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Alert,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const VerifyEmailError = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            padding: 4,
            backgroundColor: '#ffffff',
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <ErrorIcon sx={{ fontSize: 60, color: '#f44336', mb: 2 }} />
            <Typography
              component="h1"
              variant="h4"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
              }}
            >
              인증 링크 오류
            </Typography>
          </Box>

          <Alert severity="error" sx={{ mb: 3 }}>
            유효하지 않거나 만료된 인증 링크입니다.
          </Alert>

          <Typography
            variant="body1"
            sx={{
              color: '#666666',
              marginBottom: 3,
              textAlign: 'center',
            }}
          >
            인증 링크는 1시간 후에 만료됩니다.<br />
            새로운 인증 링크를 받으시려면 로그인 페이지에서 재전송을 요청해주세요.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4 }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/login')}
              disabled
              sx={{
                borderColor: '#000000',
                color: '#000000',
                '&:hover': {
                  borderColor: '#333333',
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              로그인 페이지로
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default VerifyEmailError;

